import { render, staticRenderFns } from "./ModelAddUpdate.vue?vue&type=template&id=6bfecc8c"
import script from "./ModelAddUpdate.vue?vue&type=script&lang=js"
export * from "./ModelAddUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports